module.exports = __webpack_public_path__ + "img/Nikolai.1c3a2a72.png";